<template>
  <div class="countdown">
    <Load v-if="isLoading" />
    <template v-else>
      <!-- 
        TODO: Hide campaign name
        <v-row justify="center" no-gutters>
        <v-col class="text-center">
          <h1>{{ campaignName }}</h1>
        </v-col>
      </v-row> -->
      <v-row
        v-if="!isCountdownEnd"
        class="mt-8 pt-4"
        justify="center"
        no-gutters
      >
        <h2>Start in</h2>
      </v-row>
      <v-row
        v-if="!isCountdownEnd"
        class="mt-10"
        justify="center"
        no-gutters
      >
        <CountDown
          v-if="!isCountdownEnd"
          :timeLeft="timeLeft"
          @end="onEndCountdown"
        />

        <div class="w-full"></div>

        <v-col cols="auto" class="pt-8">
          <add-to-calendar-button
            id="add-to-calendar-button"
            :name="calendarData.name"
            :label="calendarData.label"
            :options="calendarData.options"
            :startDate="calendarData.startDate"
            :endDate="calendarData.endDate"
            :description="calendarData.description"
            :startTime="calendarData.startTime"
            :endTime="calendarData.endTime"
            :timeZone="calendarData.timeZone"
          ></add-to-calendar-button>
        </v-col>
      </v-row>
      <v-row
        v-if="innerHtml"
        class="mt-8 items-center"
        justify="center"
        no-gutters
      >
        <v-col
          v-if="timeLeft < 0 || isCountdownEnd"
          cols="auto"
          class="pb-8"
        >
          <Button
            block
            color="color-bnn"
            height="48px"
            depressed
            @click="toProductDetail"
            :title="`เข้าสู่การจอง ${campaignName}`"
          />
        </v-col>
        <div class="w-full"></div>
        <div v-html="innerHtml" class="html-content"></div>
      </v-row>
    </template>
  </div>
</template>

<script>
import loadCampaign from '../utils/loadcampaign'
import Load from './Load'
import CountDown from '@/components/bnn/CountDown'
import Button from '@/components/bnn/Button'
import isBnn from '@/config/isBnn'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  computed: {
    ...mapState({
      modelLoading: state => state.model.isLoading,
      isLoaded: state => state.model.isLoaded,
      campaign: state => state.campaign.current,
      campaignData: state => state.campaign.data,
      campaignLoading: state => state.campaign.isLoading,
      startTime: state =>
        state?.campaign?.current?.data?.started_at_timestamp ||
        undefined,
      currentTime: state =>
        state?.campaign?.current?.data?.current_datetime_timestamp ||
        undefined,
      startedAt: state => state?.campaign?.current?.data?.started_at,
    }),

    isLoading() {
      return this.campaignLoading || this.modelLoading
    },

    innerHtml() {
      if (this.isCountdownEnd) {
        return this.campaign?.data?.html_after_start
      }
      return this.campaign?.data?.countdown_html
    },

    htmlAfterStart() {
      return this.campaign?.data?.html_after_start
    },

    timeLeft() {
      if (this.startTime && this.currentTime) {
        return (this.startTime - this.currentTime) * 1000
      }
      return -1
    },

    campaignName() {
      return this.campaign?.data?.name
    },

    countDownHtml() {
      return this.campaign?.data?.countdown_html
    },

    slug() {
      return this.campaign?.data?.slug
    },

    calendarData() {
      let link = `${window.location.origin}/${this.slug}/countdown`

      return {
        name: `[${isBnn ? 'BaNANA' : 'Studio7'}] PRE-ORDER ${
          this.campaign?.data?.name
        } `,
        options: "'Apple','Google','Outlook.com','iCal'",
        startDate: moment
          .utc(this.startedAt)
          .local()
          .add(-5, 'minutes')
          .format('YYYY-MM-DD'),
        endDate: moment
          .utc(this.startedAt)
          .local()
          .add(1, 'hour')
          .format('YYYY-MM-DD'),
        startTime: moment
          .utc(this.startedAt)
          .local()
          .add(-5, 'minutes')
          .format('HH:mm'),
        endTime: moment
          .utc(this.startedAt)
          .local()
          .add(1, 'hour')
          .format('HH:mm'),
        label: 'Notify Me',
        timeZone: 'Asia/Bangkok',
        description: `[p][strong]${
          isBnn ? 'BaNANA' : 'Studio7'
        } | PRE-ORDER ${
          this.campaign?.data?.name
        }[/strong][/p][hr][p]เริ่ม ${moment
          .utc(this.startedAt)
          .local()
          .format(
            'DD MMMM YYYY เวลา HH:mm น.',
          )}[p][url]${link}|${link}[/url][/p][hr]`,
      }
    },
  },

  data() {
    return {
      isCountdownEnd: false,
      isBnn,
    }
  },

  watch: {
    timeLeft(val) {
      if (val <= 0) {
        this.onEndCountdown()
      }
    },
  },

  async mounted() {
    const active = await loadCampaign(this.campaign)

    if (active) {
      document.body.style.overflowY = ''
      document.querySelector('html').style.overflowY = ''
    }

    if (this.campaign?.data?.redirect_url) {
      window.location.href = this.campaign?.data?.redirect_url
    }
  },

  methods: {
    onEndCountdown() {
      this.isCountdownEnd = true
      if (!!this.campaign?.data && !this.htmlAfterStart) {
        setTimeout(async () => {
          this.$router
            .push({
              name: 'ProductDetail',
              params: {
                slug: this.slug,
              },
            })
            .catch(() => true)
        }, 300)
      }
    },

    toProductDetail() {
      this.$router
        .push({
          name: 'ProductDetail',
          params: {
            slug: this.slug,
          },
        })
        .catch(() => true)
    },
  },

  components: {
    Load,
    CountDown,
    Button,
  },
}
</script>

<style lang="stylus" scoped>

.countdown {
  margin-top: 80px;
  height: 100%
  min-height: 100vh
}

.html-content
  width: 100%

.btn-bnn-default
  padding: 0 1.25rem !important
  font-size: 1rem !important


add-to-calendar-button#add-to-calendar-button::part(atcb-button){
	background-color: #fff
	box-shadow: none
	font-size: 14px
}
</style>
